import { Link } from "react-router-dom";
import galleryOne from "../../assets/images/gallery-1.jpeg";
import galleryTwo from "../../assets/images/gallery-8.jpg";
import galleryThree from "../../assets/images/gallery-3.jpg";
import galleryFour from "../../assets/images/gallery-9.jpg";

function GalleryPreview() {
    const images = [
        { id: 1, src: galleryOne, alt: "Sala Cris Gym 1", large: true },
        { id: 2, src: galleryTwo, alt: "Sala Cris Gym 2", large: false },
        { id: 3, src: galleryThree, alt: "Sala Cris Gym 3", large: false },
        { id: 4, src: galleryFour, alt: "Sala Cris Gym 4", large: false }
    ];

    return (
        <section className="gallery-preview">
            <div className="gallery-preview-container">
                <div className="gallery-preview-header">
                    <p className="gallery-preview-label">Galerie</p>
                    <h2 className="gallery-preview-title">
                        Descopera energia si atmosfera din sala
                    </h2>
                    <p className="gallery-preview-subtitle">
                        Un spatiu modern, bine pregatit pentru antrenamente eficiente,
                        progres constant si o experienta care te motiveaza sa revii.
                    </p>
                </div>

                <div className="gallery-preview-grid">
                    {images.map((image) => (
                        <div
                            key={image.id}
                            className={`gallery-preview-item ${image.large ? "large" : ""}`}
                        >
                            <img src={image.src} alt={image.alt} className="gallery-preview-image" />
                            <div className="gallery-preview-overlay" />
                        </div>
                    ))}
                </div>

                <div className="gallery-preview-footer">
                    <Link to="/galerie" className="gallery-preview-btn">
                        Vezi galeria completa
                    </Link>
                </div>
            </div>
        </section>
    );
}

export default GalleryPreview;